export default "__VITE_ASSET__CeT59XJ5__"